import * as React from 'react';

export default function TableContainer({ title, content, width, tableRef }) {
    const classTitle = title.replace(/\s/g, '').toLowerCase();
    return (
        <div className={`${classTitle}-table-container table-container`}>
            <h3 className={`${classTitle}-table-title table-title`}>{title}</h3>
            <table ref={tableRef} className='request-response-table' style={{ width: width }}>
                <tbody className='request-response-body'>
                    {Object.entries(content).map(([key, value]) =>
                        <tr key={key} className={`${classTitle}-row table-row`}>
                            <th className={`${classTitle}-header table-header`}>{key}</th>
                            <td className={`${classTitle}-data table-data`}>{value}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}
